import type { MenuNode } from '@/api/system';
import { menuWorkspace, type WorkspaceKey } from '@/config/workspaces';

/** 深度优先取某工作区第一个可导航路由（目录无 path，取其首个有 path 的子菜单）。 */
export function firstRouteForWorkspace(menus: MenuNode[], ws: WorkspaceKey): string {
  const inWs = menus.filter((m) => menuWorkspace(m) === ws);
  const path = findFirstPath(inWs);
  return path ?? (ws === 'mall' ? '/mall/products' : '/dashboard');
}

function findFirstPath(nodes: MenuNode[]): string | null {
  for (const n of nodes) {
    if (n.type !== 'button' && n.path) return n.path;
    if (n.children?.length) {
      const child = findFirstPath(n.children);
      if (child) return child;
    }
  }
  return null;
}

/** 某路由路径属于哪个工作区（匹配菜单 path；找不到返回 null）。 */
export function workspaceOfPath(menus: MenuNode[], path: string): WorkspaceKey | null {
  let found: WorkspaceKey | null = null;
  const walk = (nodes: MenuNode[], ws: WorkspaceKey) => {
    for (const n of nodes) {
      if (n.path && path.startsWith(n.path)) found = ws;
      if (n.children?.length) walk(n.children, ws);
    }
  };
  for (const root of menus) walk([root], menuWorkspace(root));
  return found;
}
